module.exports = __webpack_public_path__ + "img/video_thumb_01.67d031de.png";